import { gql } from "@apollo/client";

export const GET_MENU = gql`
  query Menu($culture: String!) {
    menu(where: {localization: {culture: $culture}}) {
      code {
        code
      }
      displayText
      menuItemsList {
        menuItems {
            __typename
            ... on LinkMenuItem {
            contentItemId
            displayText
            description
            externalLink
            hiddenLink
            linkMenuItem {
              name
              url
            }
            menuItemsList {
              menuItems {
                  __typename
                  ... on LinkMenuItem {
                  contentItemId
                  displayText
                  externalLink
                  linkMenuItem {
                    name
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_CULTURES = gql`
  query Menu {
    siteCultures {
      culture
    }
  }
`
